import moment from "moment-timezone";
import { STATUS } from "config/constants";

export function getContentImageSrc(content, crop = "1x1") {
  const image = content.social_image || content.primary_image;
  const imageCrops = image && image.crops[crop];
  // take last (smallest) size
  const cropSize = imageCrops && imageCrops.sizes[imageCrops.sizes.length - 1];
  return cropSize && cropSize.url;
}

export function getContentAuthorDisplay(content) {
  const author = content.authors && content.authors[0];
  if (!author) return null;
  return author.display_name || `${author.first_name} ${author.last_name}`;
}

export function getContentDateString(
  { last_updated, scheduled_date, published_date, eta, status, in_edits, lock },
  showPublishedDatetime
) {
  let dateString, lastEdited, scheduled, published, displayEta;

  // Last edited text
  const lastEditedDate = moment(last_updated).fromNow();
  // TODO: <last edited date> by <user>
  lastEdited = lastEditedDate;

  if (lock && lock.id) {
    lastEdited = `${lock.locked_by} is writing (last saved ${lastEditedDate})`;
  }

  if (in_edits) {
    lastEdited += " (in edits)";
  }

  // Display "Ready by" text
  if (
    eta &&
    [
      STATUS.UNASSIGNED.slug,
      STATUS.READY_FOR_EDITS.slug,
      STATUS.IN_PROGRESS.slug,
    ].includes(status)
  ) {
    const dateString = moment(eta).format("MMM D");
    displayEta = `Ready by ${dateString}`;
  }

  // Display "Scheduled for" text.
  if (status === STATUS.SCHEDULED.slug && scheduled_date) {
    const scheduledForToday = moment().isSame(scheduled_date, "day");
    const scheduledDateString = moment(scheduled_date).format("MMM D");
    const scheduledTimeString = moment(scheduled_date).format("h:mma zz");
    scheduled = `Scheduled for ${
      !scheduledForToday ? `${scheduledDateString} at ` : ""
    }${scheduledTimeString}`;
  }

  // Display "Published at" date.
  if (status === STATUS.PUBLISHED.slug && published_date) {
    const publishedToday = moment().isSame(published_date, "day");
    const publishedDateString = moment(published_date).format("MMM D");
    const publishedTimeString = moment(published_date).format("h:mma zz");
    published = `Published${
      !publishedToday ? ` on ${publishedDateString}` : ""
    } at ${publishedTimeString}`;
  }

  if (showPublishedDatetime) {
    if (status !== STATUS.SCHEDULED.slug) {
      dateString = published;
    } else {
      dateString = scheduled;
    }
  } else {
    dateString = [lastEdited, displayEta, scheduled]
      .filter(val => val)
      .join(" • ");
  }
  return dateString;
}

export function getSeriesContentPrefixes(contents, numberingOverride) {
  // lifted logic from axios-site-api resolver
  let contentPrefixNumber = 1;
  return contents.map(
    story => numberingOverride[story] || `${contentPrefixNumber++}.`
  );
}

export function getCurationDateString({
  created_date,
  published_date,
  status,
}) {
  // Curation status is currently only either draft/published
  if (status === STATUS.PUBLISHED.slug && published_date) {
    const publishedToday = moment().isSame(published_date, "day");
    const publishedDateString = moment(published_date).format("MMM D");
    const publishedTimeString = moment(published_date).format("h:mma zz");
    return `Published${
      !publishedToday ? ` on ${publishedDateString}` : ""
    } at ${publishedTimeString}`;
  } else {
    const createdToday = moment().isSame(created_date, "day");
    const createdDateString = moment(created_date).format("MMM D");
    const createdTimeString = moment(created_date).format("h:mma zz");
    return `Created ${
      !createdToday ? ` on ${createdDateString}` : ""
    } at ${createdTimeString}`;
  }
}
